import ChartWidgetContainer from "../../Componant/Widget/ChartWidgets";

const ChartWidget = () => {
  return (
    <div className="page-body">
      <ChartWidgetContainer />
    </div>
  );
};

export default ChartWidget;
